import { Button, FormControl, FormLabel, Input, Stack, Typography } from '@mui/joy';
import React, { useState } from 'react';
import { serviceFacade } from '../services/service-facade';
import { recentRoundsService } from '../services/recent-rounds-service';
import { useNavigate } from 'react-router';

const CreateRound = () => {

    const [roundName, setRoundName] = useState('');
    const [playerName, setPlayerName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleStartRound = async () => {
        try {
            setIsLoading(true);
            const response = await serviceFacade.createRound(roundName, playerName);
            const round = response.body.round;
            const player = response.body.player;
            recentRoundsService.updateRecentRounds(round.id, round.name, round.date, player.id, player.name, round.expires_at);
            navigate(`/${round.id}/${player.id}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Stack spacing={4}>
            <Typography level="h2">Create New Round</Typography>
            <FormControl>
                <FormLabel>Round Name</FormLabel>
                <Input
                    placeholder="Enter round name"
                    value={roundName}
                    onChange={(e) => setRoundName(e.target.value)}
                />
            </FormControl>
            <FormControl>
                <FormLabel>Player Name</FormLabel>
                <Input
                    placeholder="Enter your name"
                    value={playerName}
                    onChange={(e) => setPlayerName(e.target.value)}
                />
            </FormControl>
            <Button
                onClick={handleStartRound}
                loading={isLoading}
                disabled={isLoading}
            >
                Start Round
            </Button>
        </Stack>
    );
};
export default CreateRound;
